import { Book, Chapter } from '../../../types';

interface NextButtonProps {
  nextChapter?: Chapter;
  book: Book;
}

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M6 9h6V5l7 7-7 7v-4H6V9z" />
  </svg>
);

export const NextButton = ({ nextChapter, book }: NextButtonProps) => {
  if (!nextChapter)
    return (
      <a class="secondary" role="button" href={`/f/${book.permalink}`}>
        <Icon />
      </a>
    );

  return (
    <a
      class="secondary"
      role="button"
      href={`/f/${book.permalink}/c/${nextChapter.permalink}`}
    >
      <Icon />
    </a>
  );
};
